export type AuthErrorCode =
  | 'auth/invalid-credentials'
  | 'auth/user-not-found'
  | 'auth/email-already-in-use'
  | 'auth/weak-password'
  | 'auth/operation-not-allowed'
  | 'auth/wrong-password'
  | 'auth/network-error'
  | 'auth/permission-denied'
  | 'auth/forbidden-role'
  | 'auth/must-change-password'
  | 'auth/unknown';

export class DomainError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public override readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'DomainError';
  }
}

export class AuthError extends DomainError {
  constructor(code: AuthErrorCode, message: string, cause?: unknown) {
    super(code, message, cause);
    this.name = 'AuthError';
  }
}

export function isAuthError(value: unknown): value is AuthError {
  return value instanceof AuthError;
}
